export default __webpack_public_path__ + "static/media/Mapa.1fda6a8c.png";